import React, { Component } from 'react';
import {jsonUrl} from '../components/Factory' 
import Unterstutzer from '../components/Unterstutzer'; 

class UnterstutzerContainer extends Component {
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	
		setTimeout(function(){
			document.getElementById('menu-informationen').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('menu-informationen').classList.remove('active');
	}
	render() {		   
		   const { UnterstutzerPage } = this.props.resolves;
		   return (
				<Unterstutzer {...UnterstutzerPage} /> 
			)
	   
	}
}
export function getUnterstutzerPage(){
	return fetch(jsonUrl({ 
						number:1,
						type:'pages',
						slug:"unterstutzer"
					}))
				  .then(res => res.json())
				  .then(res => {
					document.title = res[0].yoast.title
					return res[0];		 
				  })
}
export default UnterstutzerContainer;


// WEBPACK FOOTER //
// ./src/containers/UnterstutzerContainer.js